import { AllModels, SupportedModels, OtherModels } from '../api/types'

export const getModelType = (model: string): AllModels => {
  return /toyota/i.test(model)
    ? SupportedModels.Toyota
    : /lexus/i.test(model)
    ? SupportedModels.Lexus
    : OtherModels.UnsupportedModels
}
